import React, { useState } from "react";
// import alertIcon from "../../../images/alert.png";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../../assets/closeModel.png";
import CustomButton from "../../../../components/common/button/CustomButton";

interface AlertOpenQuoteProps {
  open: boolean;
  title?: string;
  onHide?: () => void;
  content?: any;
  isError?: any;
  setIsValid?: any;
  setAlertModelShow?: any;
  setShow?: any;
  // submitHandler?: () => void;
}

const AlertMessage: React.FC<AlertOpenQuoteProps> = ({
  open,
  title,
  onHide = () => {},
  content,
  setIsValid,
  isError,
  setAlertModelShow,
  setShow,
  // submitHandler = () => {}
}) => {
  const classes = useStyles();

  const closeModel = () => {
    setAlertModelShow(false);
  };

  return (
    <Popup
      open={open}
      title={title || ""}
      onHide={onHide}
      fullWidth={true}
      maxWidth={"xs"}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={onHide}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          <CustomButton
            variant="outlined"
            title="Cancel"
            onClick={onHide}
          />
          {/* <CustomButton title="Continue" onClick={submitHandler} /> */}
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <>
           {content ?
           <Alert
              sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
              severity="warning"
            >
              {content}
            </Alert>
           : <Alert
              sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
              severity="warning"
            >
              You need to save the entered values before continuing with this
              action.
            </Alert>}
          </>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default AlertMessage;
